export default __webpack_public_path__ + "//i/components/icon/svg//rail-seat-preferences.svg";